import { InfiniteMovingCards } from "./ui/infinite-moving-cards";

interface Service {
  title: string;
  description: string;
  icon: string;
}

const services: Service[] = [
  {
    title: "3D Printing",
    description: "High-quality FDM and SLA printing for rapid prototyping",
    icon: "/images/3dprinter.png",
  },
  {
    title: "CNC Machining",
    description: "Precision CNC machining for complex parts and components",
    icon: "/images/cnc.png",
  },
  {
    title: "Laser Cutting",
    description: "High-precision laser cutting and engraving services",
    icon: "/images/laser.png",
  },
  {
    title: "Injection Molding",
    description: "Custom injection molding for high-volume production",
    icon: "/images/injection.png",
  },
  {
    title: "Sheet Metal",
    description: "Precision sheet metal fabrication services.",
    icon: "/images/sheetmetal.png",
  },
  {
    title: "Plasma Cutting",
    description: "High-speed plasma cutting for various metals.",
    icon: "/images/plasma.png",
  },
  {
    title: "Water Jet Cutting",
    description: "Abrasive water jet cutting for diverse materials.",
    icon: "/images/waterjet.png",
  },
  {
    title: "CNC Routing",
    description: "Large-format CNC routing for woods and plastics.",
    icon: "/images/cncrouter.png",
  },
];

export function ServicesCarousel({
  direction = "left",
  speed = "normal",
}: {
  direction?: "left" | "right";
  speed?: "fast" | "normal" | "slow";
  pauseOnHover?: boolean;
}) {
  return (
    <div className="pt-12 flex justify-center">
      <InfiniteMovingCards
        items={services}
        direction={direction}
        speed={speed}
      />
    </div>
  );
}
